/**
 * The drafting model sometimes wraps its reply in ":::writing" / ":::writing
 * block" / bare ":::" container fences (a convention from its system prompt),
 * despite output instructions telling it not to. These fences are never valid
 * content in a draft, so we strip a leading opener and a trailing closer before
 * the reply is shown, saved, or downloaded.
 */
export function stripWritingBlock(content: string): string {
  if (!content) return content;
  let result = content.trim();
  // Opening fence at the very start, whether on its own line or inline before
  // the text (e.g. ":::writing My name is...").
  result = result.replace(
    /^:::[ \t]*(?:writing(?:[ \t]+block)?)?[ \t]*\n?/i,
    ""
  );
  // Closing fence at the very end (the model sometimes repeats ":::writing").
  result = result.replace(
    /\n?[ \t]*:::[ \t]*(?:writing(?:[ \t]+block)?)?[ \t]*$/i,
    ""
  );
  return result.trim();
}
